import { UserState } from 'types/global';
import { RECRUITER } from 'constants/index';

const getUserInfo = (user: UserState) => {
  if (user && user.role === RECRUITER) {
    return {
      companyName: user.info.companyName,
      contactPerson: user.info.contactPerson,
      contactPersonTitle: user.info.contactPersonTitle,
      phoneNumber: user.info.phoneNumber,
      recruitingLicence: user.info.recruitingLicence,
      address: user.addressInfo.address,
      country: user.addressInfo.country,
      city: user.addressInfo.city,
      province: user.addressInfo.province,
      postalCode: user.addressInfo.postalCode,
    };
  }
  return {
    companyName: user.info.companyName,
    contactPerson: user.info.contactPerson,
    contactPersonTitle: user.info.contactPersonTitle,
    phoneNumber: user.info.phoneNumber,
    companyBio: user.info.companyBio,
    address: user.addressInfo.address,
    city: user.addressInfo.city,
    province: user.addressInfo.province,
    postalCode: user.addressInfo.postalCode,
  };
};

export default getUserInfo;
